<section class="business-info__container">
  <div class="d-flex">
    <div class="business-info__container__icon">
      <span class="material-icons-round">domain</span>
    </div>

    @if (info$ | async; as company) {
      <div class="business-info__container__desc">
        <h2 class="business-info__container__desc__title">{{ company?.name }}</h2>
        <span class="business-info__container__desc__subtitle"
          >CNPJ: <strong>{{ company?.document | document }}</strong></span
          >
        </div>
      }
    </div>

    @if (showBackButton) {
      <div class="back-to-list">
        <a routerLink="/dashboard" data-testid="voltar-listagem">
          <em class="material-icons">arrow_back_ios</em>
          <span class="text-to-back">Voltar para a lista de usuários</span>
        </a>
      </div>
    }

    @if (userMeInfo$ | async) {
      <pl-recertification-date [info]="userMeInfo$"></pl-recertification-date>
    }
  </section>
